import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'

class DetailBloc {

    kuotaChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.kuotaChannel.next({status: apiResponse.INITIAL})
    }

    fetchKuotaTahunan = async (query) => {
        try {
            this.kuotaChannel.next({  status: apiResponse.LOADING })
            await this.repository.fetchKuotaTahunan(query).then((result) => {
                this.kuotaChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.kuotaChannel.next({ status: apiResponse.ERROR, data: error })
            })           
        } catch (error) {
            console.log('rxjs Unsubscribed')        
        }
    }
}

export default DetailBloc